// extracted by mini-css-extract-plugin
module.exports = {"color-white":"#fff","container":"ImageBanner_container__1tlsP"};